import script from "./safeguard.vue?vue&type=script&setup=true&lang=js"
export * from "./safeguard.vue?vue&type=script&setup=true&lang=js"

import "./safeguard.vue?vue&type=style&index=0&id=74b2eca5&lang=scss&scoped=true"
import "./safeguard.vue?vue&type=style&index=1&id=74b2eca5&lang=css"

import exportComponent from "D:\\workCode\\PC\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74b2eca5"]])

export default __exports__